import { GetPlayListParams, SavePlayListParams } from "../types/requestInputs";
import { GetPlayListResponse, SavePlayListResponse } from "../types/requestsOutputs";
import { fetchAPI } from "./utils";

// Get Playlist by Track ID
export const getPlayList = async ({ token, trackId }: GetPlayListParams): Promise<GetPlayListResponse> => {
    return fetchAPI<GetPlayListResponse>("/get-playlist", "POST", { trackId }, token);
};

// Save a Playlist for a Track
export const savePlayList = async ({ token, trackId, music }: SavePlayListParams): Promise<SavePlayListResponse> => {
    return fetchAPI<SavePlayListResponse>("/save-playlist", "POST", { trackId, music }, token);
};
